<template>
  <v-card>
    <v-card-title primary-title>
      <v-layout>
        <v-flex xs8 class="pt-4 pl-4">
          <v-layout class="H5-Primary-Left">CentricOS Local Menu Group Permissions</v-layout>
          <v-layout>
            <v-text-field
              class="Brand-Not-Selected-Error"
              :value="selectedBrands.length || selectedLocalMenuGroups.length"
            />
          </v-layout>
        </v-flex>
        <v-flex xs4 style="cursor: pointer;">
          <v-layout
            v-if="selectedLocalMenuGroups.length > 0"
            justify-end
            class="mt-3 mr-5 noselect"
            v-on:click="isAllCollapsed = !isAllCollapsed"
          >
            <div class="Body-2-Primary-On-Surface-Left">
              {{ isAllCollapsed ? 'Expand All' : 'Collapse All' }}
            </div>
            <v-icon style="color: #0d73d8;">{{
              isAllCollapsed ? 'mdi-chevron-down' : 'mdi-chevron-up'
            }}</v-icon>
          </v-layout>
        </v-flex>
      </v-layout>
    </v-card-title>
    <loading-wrapper :loading="loading">
      <v-layout class="v-card-content">
        <v-flex>
          <div v-if="selectedLocalMenuGroups.length || missingLocalMenuGroups.length">
            <v-layout>
              <v-flex xs8>
                <v-text-field
                  label="Search Local Menu Groups"
                  prepend-icon="mdi-magnify"
                  v-model="search"
                  clearable
                />
              </v-flex>
              <v-flex xs4 />
            </v-layout>
            <v-layout column style="min-height: 450px;">
              <v-flex xs12>
                <v-layout
                  v-for="(localMenuGroup, sIndex) of orderBy(
                    filterBy(selectedLocalMenuGroups, search, 'name'),
                    'name',
                  )"
                  v-bind:key="sIndex"
                  class="LocalMenuGroup-Permissions-Container px-3 mt-2 mb-2 noselect"
                >
                  <v-flex>
                    <v-layout>
                      <v-flex style="cursor: pointer;" @click="expand(localMenuGroup)">
                        <v-layout>
                          <div class="H6-Secondary-Left">
                            {{ localMenuGroup.name || 'Untitled' }}
                          </div>
                        </v-layout>
                        <v-layout>
                          <v-text-field
                            class="Brand-Not-Selected-Error"
                            :value="getSelectedBrands(localMenuGroup).length"
                          />
                        </v-layout>
                      </v-flex>
                      <v-flex xs4>
                        <v-layout justify-end>
                          <v-flex>
                            <v-layout justify-end>
                              <v-btn
                                flat
                                color="#090c9b"
                                v-on:click="removeLocalMenuGroup(localMenuGroup.id)"
                              >
                                <v-icon class="mr-1" left>mdi-delete-outline</v-icon>REMOVE
                              </v-btn>
                            </v-layout>
                          </v-flex>
                          <v-flex @click="expand(localMenuGroup)">
                            <v-layout style="cursor: pointer; margin-top: 0px;" justify-center>
                              <v-icon>{{
                                expansionPanelValues[localMenuGroup.id]
                                  ? 'mdi-chevron-up'
                                  : 'mdi-chevron-down'
                              }}</v-icon>
                            </v-layout>
                          </v-flex>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                    <v-layout
                      style="cursor: pointer;"
                      @click="expand(localMenuGroup)"
                      class="my-1"
                      v-if="!expansionPanelValues[localMenuGroup.id]"
                    >
                      <v-flex>
                        User has access to&nbsp;
                        <b
                          >{{ localMenuGroup.totalSelected }}/{{
                            localMenuGroup.total
                          }}&nbsp;brands</b
                        >
                        &nbsp;at {{ localMenuGroup.name || 'Untitled' }}
                      </v-flex>
                    </v-layout>
                    <v-layout class="pl-2" v-else justify-start>
                      <v-flex>
                        <v-layout
                          v-on:click="toggleBrandsSelection(localMenuGroup.id)"
                          style="margin-top: -20px; margin-bottom: -15px;"
                        >
                          <v-checkbox
                            label="Select All"
                            v-model="selectedLocalMenuGroupsCache[localMenuGroup.id].isAllSelected"
                            :value="true"
                            disabled
                          />
                        </v-layout>
                        <v-layout>
                          <v-text-field
                            class="Brand-Not-Selected-Error"
                            :rules="
                              appSelectionRules(
                                localMenuGroup.totalSelected || localMenuGroup.isAllSelected,
                              )
                            "
                            :value="
                              Object.keys(selectedLocalMenuGroupsCache[localMenuGroup.id].brands)
                            "
                          />
                        </v-layout>
                        <v-layout>
                          <v-list>
                            <v-list-tile
                              v-for="(brand, bIndex) of getBrands(localMenuGroup.id)"
                              v-bind:key="bIndex"
                              :label="brand.name"
                            >
                              <v-list-tile-action>
                                <div v-on:click="toggleBrandSelection(localMenuGroup.id)">
                                  <v-checkbox
                                    v-model="
                                      selectedLocalMenuGroupsCache[localMenuGroup.id].brands[
                                        brand.id
                                      ].isSelected
                                    "
                                    :label="`${brand.name}`"
                                    disabled
                                  />
                                </div>
                              </v-list-tile-action>
                            </v-list-tile>
                          </v-list>
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12 v-if="missingLocalMenuGroups.length">
                <v-layout
                  class="ml-1 mr-1 mb-3 H7-Secondary-Left font-weight-bold"
                  style="color: #ea526f"
                  >The following Local Menu Group ID(s) can no longer be found and may have been
                  deleted, consider removing the permissions below to avoid conflicts. If this is
                  incorrect, please contact a system administrator:</v-layout
                >
                <v-layout
                  v-for="(missingLocalMenuGroupId, index) of missingLocalMenuGroups"
                  v-bind:key="index"
                  class="LocalMenuGroup-Permissions-Container px-3 mt-2 mb-2 noselect"
                >
                  <v-flex>
                    <v-layout>
                      <v-flex>
                        <v-tooltip top nudge-right="100" close-delay="1000">
                          <template v-slot:activator="{ on, attrs }">
                            <v-layout class="H7-Secondary-Left ma-0" v-bind="attrs" v-on="on">
                              {{ missingLocalMenuGroupId.slice(0, 50).concat('...') }}
                            </v-layout>
                          </template>
                          <span>{{ missingLocalMenuGroupId }}</span>
                        </v-tooltip>
                      </v-flex>
                      <v-flex xs4>
                        <v-layout justify-end>
                          <v-flex>
                            <v-layout justify-end>
                              <v-btn
                                flat
                                color="#090c9b"
                                v-on:click="removeLocalMenuGroup(missingLocalMenuGroupId)"
                              >
                                <v-icon class="mr-1" left>mdi-delete-outline</v-icon>REMOVE
                              </v-btn>
                            </v-layout>
                          </v-flex>
                          <v-flex xs3 lg4 />
                        </v-layout>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
            <v-layout justify-start class="pl-4 mt-4 mb-2 mr-5">
              <div
                class="Body-2-Primary-On-Surface-Left noselect"
                style="text-decoration: underline; cursor: pointer;"
                v-on:click="dialog = true"
              >
                Edit Local Menu Group Permissions
              </div>
            </v-layout>
          </div>
          <div v-else class="Body-1-Primary-Left Permissions-Link" v-on:click="dialog = true">
            <div v-if="selectedLocalMenuGroups.length === 0">Choose Local Menu Groups</div>
          </div>
          <permissions-dialog
            :dialog.sync="dialog"
            :selectedLocalMenuGroups.sync="selectedLocalMenuGroupsCache"
          />
        </v-flex>
      </v-layout>
    </loading-wrapper>
  </v-card>
</template>

<script>
import { mapActions } from 'vuex';
import filters from 'vue2-filters';
import cloneDeep from 'lodash/cloneDeep';
import PermissionsDialog from './localMenuGroupsSelectorDialog.vue';
import { MenuPermissionTypes, LocalMenuGroupPermissions } from '../../../constants';

export default {
  mixins: [filters.mixin],
  components: {
    PermissionsDialog,
  },
  props: ['permissions', 'permissionsStatic', 'userId'],
  data: () => ({
    dialog: false,
    selectedLocalMenuGroupsCache: {},
    search: '',
    brandDescMap: {},
    isAllCollapsed: true,
    permissionScopesProxy: [],
    expansionPanelValues: {},
    loading: false,
    error: false,
    missingLocalMenuGroups: [],
    localMenuGroupMap: {},
    brandMap: {},
    appSelectionRules: (n) => [() => !!n || 'Please select at least 1 brand'],
    permissionRules: (n) => [() => !!n || 'Please select at least 1 brand'],
  }),
  computed: {
    selectedLocalMenuGroups() {
      const localMenuGroups =
        Object.keys(this.selectedLocalMenuGroupsCache).map((localMenuGroupId) => {
          let totalSelected = 0;
          let total = 0;
          const localMenuGroup = this.selectedLocalMenuGroupsCache[localMenuGroupId];
          Object.keys(localMenuGroup.brands).forEach((b) => {
            if (localMenuGroup.brands[b].isSelected) totalSelected += 1;
            total += 1;
          });
          return { ...localMenuGroup, totalSelected, total };
        }) || [];
      return localMenuGroups;
    },
    selectedBrands() {
      try {
        return this.selectedLocalMenuGroups.map((s) => s.brands && Object.keys(s.brands)).flat();
      } catch {
        return [];
      }
    },
  },
  watch: {
    isAllCollapsed(c) {
      Object.keys(this.selectedLocalMenuGroupsCache).forEach((s) => {
        this.$set(this.expansionPanelValues, s, !c);
      });
    },
    selectedLocalMenuGroups(s) {
      const extraPermissions = this.permissions.scopes.filter(
        (scope) => !scope.includes(`:${MenuPermissionTypes.localMenuGroup}:`),
      );
      const scopes = [];
      s.forEach((localMenuGroup) => {
        LocalMenuGroupPermissions.forEach((permission) =>
          scopes.push(permission.replace('{{id}}', localMenuGroup.id)),
        );
      });
      scopes.push(...extraPermissions);
      scopes.sort();
      this.$emit('update:permissions', { scopes });
    },
    permissionsStatic(p) {
      // do the backwards mapping
      if (Object.keys(this.localMenuGroupMap).length !== 0) {
        this.mapPropsToCache(p);
      }
    },
  },
  methods: {
    ...mapActions('centricOSMenu', ['getMenuLocalMenuGroup', 'getMenuBrand']),
    async expand(localMenuGroup) {
      this.$set(
        this.expansionPanelValues,
        localMenuGroup.id,
        !this.expansionPanelValues[localMenuGroup.id],
      );
    },
    async removeLocalMenuGroup(id) {
      const localMenuGroup = this.selectedLocalMenuGroupsCache[id];
      const localMenuGroupName = localMenuGroup?.name || 'Untitled';
      const input = await this.$confirm({
        title: 'Remove Local Menu Group from Permissions?',
        message: `Are you sure you want to remove ${localMenuGroupName} from this user's local menu group permission?`,
        buttonTrueText: 'REMOVE',
        buttonFalseText: 'CANCEL',
      });
      if (input) {
        this.selectedLocalMenuGroupsCache[id] = undefined;
        delete this.selectedLocalMenuGroupsCache[id];
      }
      if (this.missingLocalMenuGroups.includes(id)) {
        this.missingLocalMenuGroups = this.missingLocalMenuGroups.filter((lmgId) => lmgId !== id);
      }
    },
    getBrands(localMenuGroupId) {
      const localMenuGroup = this.selectedLocalMenuGroupsCache[localMenuGroupId];
      const { brands } = localMenuGroup;
      return Object.values(brands) || [];
    },
    toggleBrandSelection(localMenuGroupId) {
      const localMenuGroup = this.selectedLocalMenuGroupsCache[localMenuGroupId];
      this.setLocalMenuGroup(localMenuGroup.id, { ...localMenuGroup, isAllSelected: false });
    },
    toggleBrandsSelection(localMenuGroupId) {
      const localMenuGroup = this.selectedLocalMenuGroupsCache[localMenuGroupId];
      const { brands } = localMenuGroup;
      Object.keys(brands).forEach((b) => {
        const brand = brands[b];
        this.setBrand(localMenuGroup.id, { ...brand, isSelected: localMenuGroup.isAllSelected });
      });
    },
    setBrand(localMenuGroupId, brand) {
      const localMenuGroup = this.selectedLocalMenuGroupsCache[localMenuGroupId];
      this.$set(this.selectedLocalMenuGroupsCache, localMenuGroupId, {
        ...localMenuGroup,
        brands: {
          ...localMenuGroup.brands,
          [brand.id]: {
            ...brand,
          },
        },
      });
    },
    setLocalMenuGroup(localMenuGroupId, localMenuGroup) {
      this.$set(this.selectedLocalMenuGroupsCache, localMenuGroupId, localMenuGroup);
    },
    mapPropsToCache(p) {
      // do the backwards mapping
      const selectedLocalMenuGroupsCache = {};
      if (p.scopes && Array.isArray(p.scopes)) {
        p.scopes.sort().forEach((s) => {
          const roleInfo = s.split(':');
          const permissionType = roleInfo[1];
          const id = roleInfo[2];
          if (permissionType === MenuPermissionTypes.localMenuGroup && id !== '*') {
            if (!this.localMenuGroupMap[id]) return;
            if (!selectedLocalMenuGroupsCache[id])
              selectedLocalMenuGroupsCache[id] = cloneDeep(this.localMenuGroupMap[id]);
            selectedLocalMenuGroupsCache[id].isAllSelected = true;
            const { brands } = selectedLocalMenuGroupsCache[id];
            Object.keys(brands).forEach((b) => {
              brands[b].isSelected = true;
            });
          } else if (permissionType === MenuPermissionTypes.brand && id !== '*') {
            // find corresponding localMenuGroup
            const localMenuGroupId = this.brandMap[id].local_menu_group.id;
            if (!selectedLocalMenuGroupsCache[localMenuGroupId]) {
              selectedLocalMenuGroupsCache[localMenuGroupId] = cloneDeep(
                this.localMenuGroupMap[localMenuGroupId],
              );
              Object.keys(selectedLocalMenuGroupsCache[localMenuGroupId].brands).forEach(
                (brandId) => {
                  selectedLocalMenuGroupsCache[localMenuGroupId].brands[brandId].isSelected = false;
                },
              );
            }
            if (!selectedLocalMenuGroupsCache[localMenuGroupId].brands)
              selectedLocalMenuGroupsCache[localMenuGroupId].brands = {};
            selectedLocalMenuGroupsCache[localMenuGroupId].brands[id] = cloneDeep({
              ...this.brandMap[id],
              isSelected: true,
            });
          }
        });
      }
      Object.keys(selectedLocalMenuGroupsCache).forEach((s) => {
        selectedLocalMenuGroupsCache[s].isAllSelected =
          p.scopes.find((scope) => scope.includes(`${MenuPermissionTypes.localMenuGroup}:${s}`)) &&
          Object.values(selectedLocalMenuGroupsCache[s].brands).every((b) => b.isSelected);
      });
      this.$set(this, 'selectedLocalMenuGroupsCache', selectedLocalMenuGroupsCache);
    },
    getSelectedBrands(localMenuGroup) {
      try {
        return Object.values(localMenuGroup.brands);
      } catch {
        return [];
      }
    },
    hasAllLocalMenuGroupsInfo() {
      return !(this.all_localMenuGroups === null);
    },
    getAllowedID(permissions, type) {
      const ids = [];
      permissions.scopes.forEach((permission) => {
        const roleInfo = permission.split(':');
        const permissionType = roleInfo[1];
        const id = roleInfo[2];
        if (permissionType === type && id !== '*') ids.push(id);
      });
      return ids;
    },
    async fetchMenuGroups(ids) {
      const promises = ids.map(async (id) => {
        try {
          const local_menu_group = await this.getMenuLocalMenuGroup({
            id,
            params: { relationships: '["draft_brands"]' },
          });
          const brands =
            local_menu_group.draft_brands?.reduce((acc, brand) => {
              acc[brand.id] = brand;
              return acc;
            }, {}) || {};
          return { ...local_menu_group, brands };
        } catch (err) {
          if (err.response?.status === 404) {
            if (!this.missingLocalMenuGroups.includes(id)) {
              this.missingLocalMenuGroups.push(id);
            }
            return null; // Return null for 404 errors to filter out later
          }
          throw err;
        }
      });

      const results = await Promise.all(promises);
      return results.filter((local_menu_group) => !!local_menu_group);
    },
    async getLocalMenuGroups(permissions) {
      if (!permissions.scopes || !Array.isArray(permissions.scopes)) return;
      const local_menu_group_ids = this.getAllowedID(
        permissions,
        MenuPermissionTypes.localMenuGroup,
      );
      const brand_ids = this.getAllowedID(permissions, MenuPermissionTypes.brand);

      const local_menu_groups = await this.fetchMenuGroups(local_menu_group_ids);

      const local_menu_group_brands = local_menu_groups
        .map((local_menu_group) => local_menu_group?.draft_brands)
        .flat(Infinity);

      const local_menu_group_brand_ids = local_menu_group_brands.map((brand) => brand.id);
      local_menu_group_brands.forEach((brand) => {
        if (brand) this.brandMap[`${brand.id}`] = brand;
      });
      const filtered_brand_ids = brand_ids.filter(
        (brand_id) => !local_menu_group_brand_ids.includes(brand_id),
      );
      const brands = await Promise.all(
        filtered_brand_ids.map((id) =>
          this.getMenuBrand({ id, params: { relationships: '["local_menu_group.draft_brands"]' } }),
        ),
      );

      const local_menu_groups_from_brands = brands
        .map((brand) => brand.local_menu_group)
        .flat(1)
        .map((local_menu_group) => {
          local_menu_group = { ...local_menu_group, brands: {} };
          if (local_menu_group.draft_brands) {
            local_menu_group.draft_brands.forEach((brand) => {
              local_menu_group.brands[`${brand.id}`] = brand;
            });
          }
          return local_menu_group;
        });
      const all_local_menu_groups = local_menu_groups.concat(local_menu_groups_from_brands);
      all_local_menu_groups.forEach((local_menu_group) => {
        this.localMenuGroupMap[`${local_menu_group.id}`] = local_menu_group;
      });
      brands.forEach((brand) => {
        if (brand) this.brandMap[`${brand.id}`] = brand;
      });
    },
  },

  async mounted() {
    this.loading = true;
    await this.getLocalMenuGroups(this.permissionsStatic);
    if (
      Object.keys(this.localMenuGroupMap).length !== 0 &&
      Object.keys(this.brandMap).length !== 0
    ) {
      this.mapPropsToCache(this.permissionsStatic);
    }
    this.loading = false;
  },
};
</script>

<style>
.Permissions-Link {
  text-decoration: underline;
  cursor: pointer;
}
.LocalMenuGroup-Permissions-Container {
  border-bottom: 1px solid lightgrey;
}

.Brand-Not-Selected-Error {
  padding: 0 !important;
}

.Brand-Not-Selected-Error > .v-input__control > .v-input__slot {
  display: none !important;
}
</style>
